<template>
  <div class="sender-container">
    <FriedH5 class="title">{{ $t('sender') }}</FriedH5>
    <div class="profile">
      <FriedAvatar :name="sender.fullName" :thumb-url="sender.thumbUrl" />
      <div class="sender-info">
        <FriedH5 class="sender-name">{{ sender.fullName }}</FriedH5>
        <FriedParagraph :size="ParagraphSize.Small">{{ title }}</FriedParagraph>
        <FriedParagraph :size="ParagraphSize.Small">
          {{ sender.mobile }}
        </FriedParagraph>
        <FriedParagraph :size="ParagraphSize.Small">{{ sender.email }}</FriedParagraph>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import type { SigningPageUser } from '@getaccept/lib-shared-new/src/types/signing-page-user';
import type { PropType } from 'vue';
import { computed, defineComponent } from 'vue';
import { ParagraphSize } from '@getaccept/fried-tofu';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  props: {
    sender: {
      type: Object as PropType<SigningPageUser>,
      required: true,
    },
    company: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const { t } = useI18n();
    const title = computed((): string => {
      const { title } = props.sender;
      if (title && props.company) {
        return `${title} ${t('role_at')} ${props.company}`;
      }
      if (title) {
        return title;
      }
      if (props.company) {
        return props.company;
      }
      return '';
    });

    return {
      title,
      ParagraphSize,
    };
  },
});
</script>
<style lang="scss" scoped>
.sender-container {
  width: 100%;
  display: flex;
  flex-direction: column;

  .title {
    margin-bottom: var(--spacing-100);
  }

  .profile {
    display: flex;

    .sender-info {
      padding-left: var(--spacing-100);
      display: flex;
      flex-direction: column;

      .sender-title {
        color: var(--text-gray);
      }
    }
  }
}
</style>
